import { cn } from "../lib/utils";
import { MEDICAL_DISCLAIMER_TEXT } from "../utils/medicalDisclaimer";

interface MedicalDisclaimerNoticeProps {
  className?: string;
}

/** Read-only health reminder. Does not change app behavior. */
const MedicalDisclaimerNotice = ({ className }: MedicalDisclaimerNoticeProps) => {
  return (
    <div
      className={cn(
        "rounded-2xl border border-border/80 bg-card px-4 py-3 shadow-sm dark:border-border/60",
        className,
      )}
    >
      <p className="text-footnote leading-relaxed text-muted-foreground">
        {MEDICAL_DISCLAIMER_TEXT}
      </p>
    </div>
  );
};

export default MedicalDisclaimerNotice;
